<template>
  <div>
    <vx-card>
      <div class="flex pb-5">
        <div class="flex-1">
          {{ $t("sections.accounting.dataForm.itemCounts", { max: notificationContracts.length }) }}
        </div>
      </div>
      <vs-table :data="notificationContracts">
        <template slot="thead">
          <vs-th>ลำดับ</vs-th>
          <vs-th>เลขที่สัญญา</vs-th>
          <vs-th>ชื่อสัญญา</vs-th>
          <vs-th>สถานะนักศึกษา (ระบบ)</vs-th>
          <vs-th>สถานะนักศึกษา (มหาลัย)</vs-th>
          <vs-th>จำนวนแผนเงินกู้ตั้งแต่ปัจจุบัน (ค่าเทอม)</vs-th>
          <vs-th>จำนวนแผนเงินกู้ตั้งแต่ปัจจุบัน (ค่าครองชีพ)</vs-th>
        </template>
        <template slot-scope="{ data }">
          <vs-tr :key="index" v-for="(row, index) in data">
            <vs-td>
              {{ index+1 }}
            </vs-td>
            <vs-td>
              <router-link :to="{ name: 'accounting-contract-detail', params: {id: row.id}}">{{ row.contractNo }}</router-link>
            </vs-td>
            <vs-td>
              {{ row.contractName }}
            </vs-td>
            <vs-td>
              {{ row.educationStatusName }}
            </vs-td>
            <vs-td>
              {{  row.educationStatusExternalName }}
            </vs-td>
            <vs-td>
              {{ loanDetailPlansTuitionFeeCount(row) }}
            </vs-td>
            <vs-td>
              {{ loanDetailPlansCostOfLivingCount(row) }}
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </vx-card>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'

const {mapActions: mapNotificationActions, mapState: mapNotificationFields } = createNamespacedHelpers('Notification')

export default {
  name: 'LoanDetailPlan',
  data () {
    return {
      loading: false
    }
  },
  async created () {
    const vm = this
    await vm.getNotificationContracts({
      action: vm.$route.params.action,
      loanDetailPlanFilter: "loanDateGteNow",
    })
  },
  computed: {
    ...mapNotificationFields(['status', 'notificationContracts']),
  },
  methods: {
    ...mapNotificationActions(['getNotificationContracts']),
    loanDetailPlansTuitionFeeCount (res){
      if (res.loan.loanDetailPlans){
        return res.loan.loanDetailPlans.filter( (loanDetail) => loanDetail.loanDetailType === "TuitionFee" ).length
      }else{
        return 0
      }
    },
    loanDetailPlansCostOfLivingCount (res){
      if (res.loan.loanDetailPlans){
        return res.loan.loanDetailPlans.filter( (loanDetail) => loanDetail.loanDetailType === "CostOfLiving" ).length
      }else{
        return 0
      }
    },
  },
  watch: {
      status: {
        handler(res) {
          if (res.processing !== null) {
            if (res.processing) {
              this.$vs.loading();
            } else {
              this.$vs.loading.close();
            }
          }
          if (res.success !== null) {
            this.$vs.notify({...res.success})
          } else if (res.error !== null) {
            this.$vs.notify({...res.error})
          }
        },
        deep: true
      },
  }
}
</script>
